export default "__VITE_ASSET__6900f56a__"